import {
  REGISTER_SUCCESS,
  REGISTER_FAIL,
  USER_LOADED,
  AUTH_ERROR,
  LOGIN_SUCCESS,
  LOGIN_FAIL,
  LOGOUT,
  ACCOUNT_DELETED,
  ADD_TO_FAVORITES,
  DELETE_FROM_FAVORITES,
} from '../actions/types';

const initialState = {
  token: localStorage.getItem('token'),
  isAuthenticated: null,
  loading: true,
  user: null
}

export const auth = (state = initialState, { type, payload }) => {
  switch (type) {
    case ADD_TO_FAVORITES:
      return {
        ...state,
        isAuthenticated: true,
        loading: false,
        user: {...state.user,favorites:[...state.user.favorites,payload]}
      };

      case DELETE_FROM_FAVORITES:
        return {
        ...state,
        isAuthenticated: true,
        loading: false,
        user:{...state.user,favorites:[...state.user.favorites.filter(fav => fav !== payload)]}};

    case USER_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        loading: false,
        user: payload
      };

    case REGISTER_SUCCESS:
    case LOGIN_SUCCESS:
      localStorage.setItem('token', payload.token);
      return {
        ...state,
        ...payload,
        isAuthenticated: true,
        loading: false
      };

    case REGISTER_FAIL:
    case AUTH_ERROR:
    case LOGIN_FAIL:
    case LOGOUT:
    case ACCOUNT_DELETED:
      localStorage.removeItem('token');
      return {
        ...state,
        token: null,
        isAuthenticated: false,
        loading: false,
        user: null,
      };

    default:
      return state;
  }
}